import React from 'react';
import PartnerSection from '../PartnerSection';
import CountUp from 'react-countup';
import sIcon1 from '../../images/icons/icon_head.svg'
import sIcon2 from '../../images/icons/icon_check.svg'
import sIcon3 from '../../images/icons/icon_like.svg'
import sIcon4 from '../../images/icons/icon_dart_board.svg'
import icon_user_rating from '../../images/icons/icon_user_rating.svg'
//import icon_react_js from '../../images/icons/icon_react_js.svg'
import icon_retention_rate from '../../images/icons/icon_user_check.svg'
// import fimg from '../../images/about/about_image_1.webp'
import fimg from '../../images/about/NEW/Future.png'
import icon_quality from '../../images/icons/icon_quality.svg'
import icon_satisfaction from '../../images/icons/icon_satisfaction.svg'
import './FeaturesSection.css';


const FunFact = [
  {
    id: 1,
    title: '4',
    subTitle: 'Years of Experience',
    symbol: '+',
    icon: sIcon1,
  },
  {
    id: 2,
    title: '35',
    subTitle: 'Success Stories',
    symbol: '+',
    icon: sIcon2,
  },
  {
    id: 3,
    title: '30',
    subTitle: 'Companies Trust Us',
    symbol: '+',
    icon: sIcon3,
  },
  {
    id: 4,
    title: '90',
    subTitle: 'Results Guaranteed',
    symbol: '%',
    icon: sIcon4,
  },
  {
    id: 5,
    title: '92',
    subTitle: 'Customer Satisfaction',
    symbol: '%',
    icon: icon_satisfaction,
  },
  {
    id: 6,
    title: '92',
    subTitle: 'Project Success Rate',
    symbol: '%',
    icon: icon_user_rating,
  },
  {
    id: 7,
    title: '88',
    subTitle: 'Retention Rate',
    symbol: '%',
    icon: icon_retention_rate,
  },
  {
    id: 8,
    title: '92',
    subTitle: 'Quality Assurance Score',
    symbol: '%',
    icon: icon_quality,
  }
];



const FeaturesSection = (props) => {

  return (
    <section
      className="features-section"
    >
      <div className="container">
        <PartnerSection />

        <div className="row align-items-stretch">
          <div className="col-lg-8 d-flex flex-column pd-0">
            <div className="row flex-grow-1">
              {FunFact.map((item, index) => (
                <div className="col-sm-6 mb-4" key={index}>
                  <div className="funfact-card h-100 ">
                    <img src={item.icon} alt="Icon" className="funfact-icon" loading='lazy' />
                    <div>
                      <div className="counter-value">
                        <CountUp end={parseInt(item.title)} enableScrollSpy />
                        {item.symbol}
                      </div>
                      <div className="funfact-title">{item.subTitle}</div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="col-lg-4 mt-4 mt-lg-0 d-flex">
            <div className="employee-box flex-grow-1 d-flex align-items-center justify-content-center pd-7">
              <img src={fimg} alt="Employees" className="img-fluid m-0" loading='lazy'/>
            </div>
          </div>
        </div>

      </div>
    </section>

  );
}

export default FeaturesSection;